// extracted by mini-css-extract-plugin
export var numpadContainer = "_s1-1";
export var phoneButton = "_s1-0";